/*
  Vérificateur de compatibilité imprimante (fiche produit).
  Normalisation : minuscules, accents retirés, espaces / tirets / points / underscores supprimés.
  Un modèle correspond si la saisie normalisée est contenue dans le nom normalisé
  (« tml100 » trouve « Epson TM L100 »). Saisie minimale : 3 caractères.
*/
(function () {
  function normaliser(texte) {
    return String(texte || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[\s\-_.\/]/g, '');
  }

  document.querySelectorAll('[data-tsi-compat]').forEach(function (bloc) {
    var saisie = bloc.querySelector('[data-tsi-compat-saisie]');
    var resultat = bloc.querySelector('[data-tsi-compat-resultat]');
    var modeleOk = bloc.querySelector('[data-tsi-compat-ok]');
    var modeleKo = bloc.querySelector('[data-tsi-compat-ko]');
    var liste = [];
    try {
      liste = JSON.parse(bloc.querySelector('[data-tsi-compat-liste]').textContent) || [];
    } catch (e) {
      return;
    }
    var index = liste.map(function (nom) { return { nom: nom, cle: normaliser(nom) }; });
    var minuterie;

    function verifier() {
      var cle = normaliser(saisie.value);
      resultat.innerHTML = '';
      if (cle.length < 3) return;
      var trouve = null;
      for (var i = 0; i < index.length; i++) {
        if (index[i].cle.indexOf(cle) !== -1) { trouve = index[i].nom; break; }
      }
      var fragment = (trouve ? modeleOk : modeleKo).content.cloneNode(true);
      if (trouve) fragment.querySelector('[data-tsi-compat-modele]').textContent = trouve;
      resultat.appendChild(fragment);
    }

    saisie.addEventListener('input', function () {
      clearTimeout(minuterie);
      minuterie = setTimeout(verifier, 200);
    });
  });
})();
